// extracted by mini-css-extract-plugin
export default {"spinner_container":"styles_spinner_container__IPl8u","spinner":"styles_spinner__Z3j0P","spin":"styles_spin__E5sYE"};